import SiteHeader from "./site-header.vue";

const promise = new Promise(resolve => {
  vueApp.component('site-header', SiteHeader);
  resolve();
});

window.pendingComponentLoads.push(promise);
